import { Flex } from '@wyz/ui';
import { Trans, useI18n } from '~/common/context';
import { SearchValuePreview } from '~/purchase/components';
import { IWcwSearchFormSchema } from '~/purchase/schemas';

type Props = {
  searchQuery: IWcwSearchFormSchema | undefined;
};

function WcwSearchPreview({ searchQuery }: Props) {
  const { t } = useI18n();

  return (
    <Flex
      justifyContent='between'
      alignItems='center'
      wrap='wrap'
      className='gap-2'
    >
      <Flex className='space-x-4' wrap='wrap'>
        <SearchValuePreview
          label={<Trans i18nKey='app.purchase.search_page.vehicle_type' />}
          value={searchQuery?.vehicleTypeGroup}
        />
        <SearchValuePreview
          label={<Trans i18nKey='app.purchase.wcw.search_page.brand' />}
          value={searchQuery?.brand ?? undefined}
        />
        <SearchValuePreview
          label={<Trans i18nKey='app.purchase.wcw.search_page.model' />}
          value={searchQuery?.model ?? undefined}
        />
        <SearchValuePreview
          label={<Trans i18nKey='app.purchase.wcw.search_page.versions' />}
          value={
            searchQuery?.versions?.length
              ? t('app.common.items_count', {
                  count: searchQuery.versions.length,
                })
              : undefined
          }
        />
        <SearchValuePreview
          label={<Trans i18nKey='app.common.product.season' />}
          value={
            searchQuery?.seasons?.length
              ? t('app.common.items_count', {
                  count: searchQuery.seasons.length,
                })
              : undefined
          }
        />
        <SearchValuePreview
          label={<Trans i18nKey='app.common.quantity' />}
          value={
            searchQuery?.set != null
              ? t('app.purchase.wcw.search_page.set_option', {
                  count: searchQuery.set,
                })
              : undefined
          }
        />
      </Flex>
    </Flex>
  );
}

export default WcwSearchPreview;
